import * as moment from 'moment';
import {Component, Input, OnInit} from '@angular/core';

import {
    DownloadState,
    DownloadStatusLabels, UploadAssetsService, UploadState, UploadStatus,
    UploadStatusLabels
} from "../../services/upload-assets.service";
import {SettingsService} from "../../pages-services";

@Component({
    selector: 'app-upload-assets',
    templateUrl: './upload-assets.component.html',
    styleUrls: ['./upload-assets.component.scss']
})
export class UploadAssetsComponent implements OnInit {

    @Input()
    assetsList;
    progress: {
        progress: number,
        info: string,
        status: string
    };

    isPackageUploading: boolean;
    activePackageIndex: number = -1;

    constructor(private uploadAssetsService: UploadAssetsService, private settingsService: SettingsService) {
    }

    ngOnInit() {
        this.progress = {
            progress: 0,
            status: '',
            info: ''
        };
        this.uploadAssetsService.uploadingProgress.subscribe(this.progressHandler.bind(this));
        this.uploadAssetsService.progressStatus.subscribe((status) => {
            this.isPackageUploading = status;
        });
    }

    formatTime(time) {
        return moment(time).format('DD/MM/YY, HH:mm');
    }


    packageUpload($event) {
        const fileField = $event.target;
        const {files} = fileField;
        const path = `assets`;
        const fileToUpload = files.item(0);
        this.uploadAssetsService.uploadPackage(fileToUpload).subscribe(this.progressHandler.bind(this));

        // this.settingsService.uploadFile(fileToUpload, path).subscribe(
        //     async (response) => {
        //         this.isPackageUploading = false;
        //         fileField.value = '';
        //         this.toasterService.pop(
        //             'success',
        //             '',
        //             await this.translationService.get('webpanel.media.file_uploaded_successfully').toPromise()
        //         );
        //         this.getSettingsData();
        //     },
        //     async (error) => {
        //         this.isPackageUploading = false;
        //         fileField.value = '';
        //         this.logger.error('packageUpload: ', error);
        //         this.toasterService.pop(
        //             'error',
        //             await this.translationService.get('webpanel.media.file_upload_error').toPromise(),
        //             error.message,
        //         );
        //         this.getSettingsData();
        //     }
        // );
    }

    uploadExistingPackage(id) {
        this.settingsService.uploadExistingPackage(id).subscribe(res => {
            console.log(res);
        });
    }

    progressHandler(state: UploadState|DownloadState) {
        if (state.status === UploadStatus.Finished) {
            this.progress = {
                progress: 0,
                status: '',
                info: ''
            };
        } else {
            let label = (state.type === 'upload') ? UploadStatusLabels[state.status] : DownloadStatusLabels[state.status];
            this.progress = {
                progress: state.progress,
                status: label,
                info: state.info
            };
        }
    }


    cancel() {
        this.uploadAssetsService.cancel();
    }

    download(){
        this.uploadAssetsService.downloadPackage().subscribe(this.progressHandler.bind(this));
    }

}



// WEBPACK FOOTER //
// ./src/app/components/upload-assets/upload-assets.component.ts